import React, {useEffect, useState} from 'react';
import {
    Box,
    Button,
    Drawer,
    FormControlLabel,
    Grid,
    IconButton,
    Stack,
    SvgIcon,
    Switch, TextField,
    Typography
} from "@mui/material";
import localStrings from "../../../localStrings";
import XIcon from "@untitled-ui/icons-react/build/esm/X";
import useAuth from "../../../hooks/useAuth";
import GeneralEditor from "../../../components/CrudFrom/GeneralEditor";
// import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
// import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
// import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
// import {DatePicker} from "antd";
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";

// import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from "moment";
import {filterSingleDay} from "../../../pages/Home/FilterInfoOverview";

function FilterEditor({setOpen}) {

    const {setFilter, filter} = useAuth()

    const buildFormValues = (item) => {

        return {
            initialValues: {
                singleDay: item.singleDay || dayjs(moment().format()),
            },
            validationSchema: {
                // hoursDuration: Yup.number().max(24, localStrings.check.wrongHoursValue).min(0),
                // minutesDuration: Yup.number().max(60, localStrings.check.wrongMinutesValue).min(0),
                // secondsDuration: Yup.number().max(60, localStrings.check.wrongSecondsValue).min(0),
            }
        };
    }

    const getCardContentForm = ({
                                    errors,
                                    handleBlur,
                                    handleChange,
                                    handleSubmit,
                                    isSubmitting,
                                    setFieldValue,
                                    touched,
                                    values
                                }) => {
        return (

            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Grid
                    container
                    spacing={4}
                >
                    {filter?.filterType === filterSingleDay &&
                    <Grid
                        item
                        md={12}
                        xs={12}
                    >
                        <Box mt={2}>
                            <DatePicker
                                sx={{width: '100%'}}
                                label="Basic date picker"
                                value={values.singleDay}
                                onChange={(newValue) => setFieldValue('singleDay', newValue)}
                            />
                        </Box>
                    </Grid>
                    }


                </Grid>
            </LocalizationProvider>
        )

    }

    function shouldDisplay() {
        return filter?.filterType === filterSingleDay;
    }

    return (
        <div style={{width: '100%'}}>
            {shouldDisplay() &&
                <GeneralEditor
                    displaySaveButton
                    itemSource={filter || {}}
                    buildFormValues={buildFormValues}
                    getCardContentForm={getCardContentForm}
                    saveForm={(item, values) =>
                    {
                        setFilter(
                        {
                            ...filter,
                            ...values
                        })
                        setOpen(false)
                    }}
                    hideApplyButton={false}
                    applyButton={localStrings.update}
                    resetFormProp={true}
                    messageSuccess={localStrings.notif.filterUpdated}
                    //titleForm={mediaSequenceEdited?.name}
                    getPathToData={(result) => {
                        return result;
                    }}
                >
                </GeneralEditor>
            }
        </div>
        // </Drawer>
    )
}

export default FilterEditor